import { render, staticRenderFns } from "./OpenStatistics.vue?vue&type=template&id=3077bf0e&scoped=true&"
import script from "./OpenStatistics.vue?vue&type=script&lang=js&"
export * from "./OpenStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3077bf0e",
  null
  
)

export default component.exports